<script>
let base64 = require("js-base64").Base64;
import qs from "qs";
import GlobalConfig from "../../assets/js/config/global";

export default {
  layout: "empty",
  data () {
    // 这里存放数据
    return {};
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    // 钉钉免登
    notLogin () {
      const { query } = this.$route,
        _this = this;
      let corpId = "";
      console.log("query", query);
      this.$jzqCookie.set("jtoken", this.$route.query.t);
      if (query.ap) {
        corpId = query.ap.split("=")[1];
      }
      if (dd.env.platform != "notInDingTalk") {
        //在钉钉环境内部
        dd.runtime.permission.requestAuthCode({
          corpId,
          onSuccess: function (info) {
            //通过获取的免登授权码后请求后台接口获取token登录应用，并将token存入缓存
            console.log("获取到免登授权码", info);
            dingtalkApi
              .login({
                corpId,
                requestAuthCode: info.code
              })
              .then(res => {
                if (!res.success) _this.$message.error(res.description);
                sessionStorage.setItem("dingloginInfo", JSON.stringify(res.data));
                _this.$router.push({ path: "/dingtalkUse/authentication" });
              });
          },
          onFail: function (err) {
            console.log("钉钉获取免登授权码错误，请稍后重试！");
          }
        });
      }
    },
    //
    toAccountAuth (url) {
      /*
      dignding 判断用户类型
      * @param PERSON 0  个人
      * @param GROUP 1 集团（个人加入的企业）
      */
      localStorage.clear();
      this.$jzqCookie.remove("jtoken");
      this.$jzqCookie.remove("ut");
      this.$jzqCookie.remove("st");
      const custAP = decodeURIComponent(url.ap).split("?");
      const _AP = qs.parse(custAP[1]);
      if (_AP.tokenKey && _AP.token) {
        localStorage.setItem("JZQ_SIGN_TOKEN_KEY", _AP.tokenKey);
        localStorage.setItem("JZQ_SIGN_TOKEN", _AP.token);
      }
      if (url.t) {
        const { s, ut, ct, corpUserId } = JSON.parse(
          Base64.decode(decodeURIComponent(url.t))
        ),
          _ap = url.ap;
        const ap = encodeURIComponent(_ap); //访问页面
        const cp = encodeURIComponent(
          // GlobalConfig.domain.junziqianOp + "/login/authorize"
          GlobalConfig.domain.junziqianWebOp + "/login/authorize"
        ); //授权设置cookie页面
        const path = `${GlobalConfig.domain.accountWeb}/login/authentication?ap=${ap}&cp=${cp}&s=${s}&t=${ut}`;
        location.href = ct ? `${path}&ct=${ct}` : path;
      } else {
        // 不需要登录或者携带token，可以直接跳转
        const path = decodeURIComponent(url.ap);
        this.$router.replace({
          path
        });
      }
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created () {
    const { query } = this.$route,
      _this = this;
    let corpId = "";
    // this.notLogin();
    this.toAccountAuth(query);
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted () { }
};
</script>
<template>
  <div>
    <!-- <h1>实现钉钉小程序跳转功能页面</h1> -->
  </div>
</template>
<style lang="" scoped>
/* @import url(); 引入公共css类 */
</style>



// WEBPACK FOOTER //
// pages/dingtalkUse/middlePage.vue